// Only a successful detail response with an explicit empty array proves no services.
// Calendar/list DTOs may omit services even for bookable members.
export function hasCalendarServices(detail: unknown, successful: boolean): boolean {
  if (!successful || !detail || typeof detail !== "object" || !("merchantServices" in detail)) return true;
  const services = detail.merchantServices;
  return !Array.isArray(services) || services.length > 0;
}
